<div>
  <ng-container *ngFor="let data of sanitizedAreasOfLifeData">
    <span class="example-list-section">
    <mat-checkbox class="example-margin"
                  #item
                  [disabled]="readOnly"
                  [checked]="allItemsIsChecked(data)"
                  (change)="selectItemsOnClick(data, item.checked); emitDataEvent()">
        {{data.separator.option}}
    </mat-checkbox>
  </span>
    <span class="example-list-section">
    <ul>
      <ng-container *ngFor="let item of data.items">
         <li>
            <mat-checkbox [(ngModel)]="item.checked"
                          (ngModelChange)="updateAllComplete(data)"
                          [checked]="item.checked"
                          [disabled]="readOnly"
                          (change)="emitDataEvent()">
              {{item.option.lifeSubAreaName}}
            </mat-checkbox>
        </li>
      </ng-container>
    </ul>
  </span>
  </ng-container>
</div>

